export enum Insert
{
    table = 'table' ,
    picture = 'picture',
    link = 'link',
    video='video',
    hr='hr'
}


